<button
  class="sm-action-button"
  [class.sm-action-button--primary]="variant === 'primary'"
  [class.sm-action-button--secondary]="variant === 'secondary'"
  [class.sm-action-button--danger]="variant === 'danger'"
  [class.sm-action-button--warning]="variant === 'warning'"
  [class.sm-action-button--ghost]="variant === 'ghost'"
  [class.sm-action-button--sm]="size === 'sm'"
  [class.sm-action-button--xs]="size === 'xs'"
  [class.sm-action-button--md]="size === 'md'"
  [class.sm-action-button--lg]="size === 'lg'"
  [class.sm-action-button--tile]="size === 'tile'"
  [class.sm-action-button--full-width]="fullWidth"
  [class.sm-action-button--icon-only]="iconOnly"
  [class.sm-action-button--icon-pair]="iconOnly && !!leadingIconName && !!trailingIconName"
  [class.sm-action-button--busy]="busy"
  [type]="type"
  [disabled]="isDisabled"
  [attr.aria-label]="ariaLabel || null"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-controls]="ariaControls || null"
  [attr.title]="title || null"
  [attr.aria-busy]="busy ? 'true' : null"
  (mouseenter)="handleTooltipOpen()"
  (mouseleave)="handleTooltipClose()"
  (focus)="handleTooltipOpen()"
  (blur)="handleTooltipClose()"
  (pointerdown)="handlePointerDown($event)"
  (pointermove)="handlePointerMove($event)"
  (pointerup)="handlePointerEnd($event)"
  (pointercancel)="handlePointerEnd($event)"
  (click)="handleClick($event)">
  @if (busy) {
    <ion-spinner class="sm-action-button__spinner" name="crescent"></ion-spinner>
  }

  @if (iconOnly) {
    <sm-overflow-tooltip
      class="sm-action-button__icon-tooltip"
      [text]="effectiveTooltipText"
      [focusable]="false"
      [always]="!!tooltipText">
      <span class="sm-action-button__icon-row">
      @if (leadingIconName) {
        <ion-icon class="sm-action-button__icon" [name]="leadingIconName" aria-hidden="true"></ion-icon>
      }
      @if (trailingIconName) {
        <ion-icon class="sm-action-button__icon" [name]="trailingIconName" aria-hidden="true"></ion-icon>
      }
      </span>
    </sm-overflow-tooltip>
  } @else if (leadingIconName) {
    <ion-icon class="sm-action-button__icon" [name]="leadingIconName" aria-hidden="true"></ion-icon>
  }

  @if (!iconOnly) {
    <span class="sm-action-button__content">
      <sm-overflow-tooltip
        [text]="effectiveTooltipText"
        [focusable]="false"
        [always]="!!tooltipText">
        <ng-content></ng-content>
      </sm-overflow-tooltip>
    </span>
  }

  @if (trailingIconName && !iconOnly) {
    <ion-icon class="sm-action-button__icon" [name]="trailingIconName" aria-hidden="true"></ion-icon>
  }
</button>
